import { SET_SEARCH_QUERY, CLEAR_SEARCH_RESULTS } from 'stash/actions';
import { SEARCH_CARDS_SUCCESS, SEARCH_CARDS_ERRORED } from 'stash/actions/api';

export const initialState = {
	query: '',
	results: [],
	loading: false,
	error: null,
};

const searchReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_SEARCH_QUERY:
			return {
				...state,
				query: action.query,
				loading: true,
			};
		case SEARCH_CARDS_SUCCESS:
			return {
				...state,
				results: action.response.cards,
				loading: false,
				error: null,
			};
		case SEARCH_CARDS_ERRORED:
			return {
				...state,
				loading: false,
				error: action.response || action,
			};
		case CLEAR_SEARCH_RESULTS:
			return {
				...state,
				results: [],
				loading: false,
				error: null,
			};
		default:
			return state;
	}
};

export default searchReducer;
